export default "__VITE_ASSET__0a9b9a16__"